import { render, staticRenderFns } from "./UpdateDatastoreModal.vue?vue&type=template&id=5bb954ef"
import script from "./UpdateDatastoreModal.vue?vue&type=script&lang=js"
export * from "./UpdateDatastoreModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports